import { O as Observable, D as DOM } from './vivid-element.js';

class Reflector {
  #reflectedProperties = /* @__PURE__ */ new Map();
  #source;
  #target;
  constructor(source, target) {
    this.#source = source;
    this.#target = target;
  }
  attribute(propertyName, attributeName) {
    this.#addReflectedProperty(propertyName, {
      type: "attribute",
      destination: attributeName
    });
  }
  booleanAttribute(propertyName, attributeName) {
    this.#addReflectedProperty(propertyName, {
      type: "boolean-attribute",
      destination: attributeName
    });
  }
  property(propertyName, targetProperty, skipIfEqual = false) {
    this.#addReflectedProperty(propertyName, {
      type: "property",
      destination: targetProperty,
      skipIfEqual
    });
  }
  destroy() {
    const notifier = Observable.getNotifier(this.#source);
    for (const prop of this.#reflectedProperties.keys()) {
      notifier.unsubscribe(this.#propertyChangeHandler, prop);
    }
    this.#reflectedProperties.clear();
  }
  #addReflectedProperty(name, reflected) {
    this.#reflectedProperties.set(name, reflected);
    const notifier = Observable.getNotifier(this.#source);
    notifier.subscribe(this.#propertyChangeHandler, name);
    this.#propertyChangeHandler.handleChange(this.#source, name);
  }
  #propertyChangeHandler = {
    handleChange: (source, propertyName) => {
      const reflectedProperty = this.#reflectedProperties.get(propertyName);
      const value = source[propertyName];
      switch (reflectedProperty.type) {
        case "boolean-attribute":
          DOM.setBooleanAttribute(
            this.#target,
            reflectedProperty.destination,
            Boolean(value)
          );
          break;
        case "attribute":
          DOM.setAttribute(this.#target, reflectedProperty.destination, value);
          break;
        case "property":
          if (reflectedProperty.skipIfEqual && this.#target[reflectedProperty.destination] === value) {
            return;
          }
          this.#target[reflectedProperty.destination] = value;
          break;
      }
    }
  };
}

export { Reflector as R };
